import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useFormik } from 'formik';
import { useSnackbar } from 'notistack';
import * as yup from 'yup';
import { getCompanies, login } from '../../modules/auth';
import LoginForm from '../../components/login/LoginForm';

const validationSchema = yup.object({
  username: yup
    .string('Enter your email')
    .email('Enter a valid email')
    .required('Email is required'),
  password: yup
    .string('Enter your password')
    .min(4, 'Password should be of minimum 4 characters length')
    .required('Password is required'),
  company: yup.string('Select your company').required('Company is required'),
});

const LoginFormContainer = () => {
  const navigate = useNavigate();
  const [searchParams, setSeratchParams] = useSearchParams();
  const linkUrl = searchParams.get('linkurl') !== null && searchParams.get('linkurl') !== '' ? searchParams.get('linkurl') : '/';
  const dispatch = useDispatch();
  const { enqueueSnackbar } = useSnackbar();




  const { companies, authLogin, authLoginError, user } = useSelector(
    ({ auth }) => ({
      companies: auth.companies,
      authLogin: auth.authLogin,
      authLoginError: auth.authLoginError,
      user: auth.user,
    }),
  );

  //컴포넌트가 처음 렌더링될때 초기화함.
  useEffect(() => {
    dispatch(getCompanies());
  }, []);

  //로그인 성공/실패
  useEffect(() => {
    if (authLoginError) {
      let message =
        typeof authLoginError.response !== 'undefined'
          ? authLoginError.response.data.message
          : authLoginError.message;
      enqueueSnackbar(message, {
        variant: 'error',
      });
    }

    if (authLogin && user) {
      navigate(linkUrl);
    }
  }, [authLogin, authLoginError, user, navigate, enqueueSnackbar]);

  const formik = useFormik({
    initialValues: {
      username: '',
      password: '',
      company: '',
    },
    validationSchema: validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      let dataToSubmit = {
        username: values.username,
        password: values.password,
        company: values.company,
      };

      setSubmitting(true);

      dispatch(login(dataToSubmit));

      formik.resetForm();
      setSubmitting(false);
    },
  });

  return <LoginForm companies={companies} formik={formik} />;
};

export default LoginFormContainer;
